import Config from '@config';
import { initializeMeteringNodeLocationTypeApi } from '@gasbi/shared/common/features/meteringNodeLocationType';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringNodeLocationType = initializeMeteringNodeLocationTypeApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringNodeLocationTypeApi,
  useGetMeteringNodeLocationTypeQuery,
} = meteringNodeLocationType;
